import numeral from "numeral";
import TriggerAudioUrl from "../../trigger/trigger_audio_source";
import { Button, Descriptions, Divider, Spin, Table } from "antd";
import { useState } from "react";
import { refineTimer } from "util/refine_timer.function";
import { useSetting } from "hook/default/setting/useSetting";
import { useBailiffConvert } from "hook/bailiff/document/action/useBailiffConvert";
import { useResponsive } from "hook/useResponsive";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const PreviewCompleted = ({ audio }) => {
  // -------------------------- VAR -----------------------------
  const { mobile } = useResponsive();
  const { ratio, durationToPrice } = useSetting();
  const { loading, handleConvertAudio } = useBailiffConvert();
  // -------------------------- STATE ---------------------------
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioDuration, setAudioDuration] = useState(0);
  // -------------------------- REDUX ---------------------------
  const audioFile = audio;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderAudioPreview = () => {
    if (!audioUrl) return null;
    return (
      <div className="flex w-full flex-col gap-3 p-[16px]">
        <p className="text-[16px] text-gray-700">
          Nghe lại đoạn ghi âm đã tải lên và xác nhận
        </p>
        <audio className="w-full" controls>
          <source src={audioUrl} />
        </audio>
        {!mobile && renderAudioTable()}
        {mobile && renderDescription()}
      </div>
    );
  };

  const renderAudioTable = () => {
    if (!audioUrl || !audioFile) return null;
    const fileName = audioFile?.fileName;
    const extension = audioFile?.file?.type;
    const size = audioFile?.file?.size / 1024 / 1024;
    const labelSize = numeral(size).format("0,0.00");
    const duration = Math.ceil(audioDuration);
    const timer = refineTimer({ timer: duration });
    const labelRatio = numeral(ratio).format("0,0");
    const labelCost = durationToPrice(audioDuration);

    const columns = [
      {
        key: "fileName",
        dataIndex: "fileName",
        title: "Tên file",
        width: 150,
        render: (value) => <span className="text-[12px]">{value}</span>,
      },
      {
        key: "size",
        dataIndex: "size",
        title: "Kích cỡ (MB)",
      },
      {
        key: "timer",
        dataIndex: "timer",
        title: "Thời lượng (giây)",
      },
      {
        key: "extension",
        dataIndex: "extension",
        title: "Định dạng",
      },
      {
        key: "ratio",
        dataIndex: "ratio",
        title: "Phí chuyển đổi (đ/s)",
      },
      {
        key: "labelCost",
        dataIndex: "labelCost",
        title: "Báo giá tạm thời",
      },
    ];

    return (
      <Table
        size="small"
        columns={columns}
        bordered
        pagination={false}
        scroll={{ x: "auto" }}
        dataSource={[
          {
            fileName,
            size: labelSize,
            timer,
            extension,
            ratio: labelRatio,
            labelCost,
          },
        ]}
      />
    );
  };

  const renderDescription = () => {
    if (!audioUrl || !audioFile) return null;
    const fileName = audioFile?.fileName;
    const extension = audioFile?.file?.type;
    const size = audioFile?.file?.size / 1024 / 1024;
    const labelSize = numeral(size).format("0,0.00");
    const duration = Math.round(audioDuration);
    const timer = refineTimer({ timer: duration });
    const labelRatio = numeral(ratio).format("0,0");
    const labelCost = durationToPrice(audioDuration);

    const items = [
      {
        key: "fileName",
        label: "Tên file",
        children: <span className="text-[12px]">{fileName}</span>,
      },
      {
        key: "size",
        label: "Kích cỡ (MB)",
        children: <span className="text-[12px]">{labelSize}</span>,
      },
      {
        key: "timer",
        label: "Thời lượng (giây)",
        children: <span className="text-[12px]">{timer}</span>,
      },
      {
        key: "extension",
        label: "Định dạng",
        children: <span className="text-[12px]">{extension}</span>,
      },

      {
        key: "ratio",
        label: "Phí chuyển đổi (đ/s)",
        children: <span className="text-[12px]">{labelRatio}</span>,
      },
      {
        key: "labelCost",
        label: "Báo giá",
        children: <span className="text-[12px]">{labelCost}</span>,
      },
    ];

    return (
      <Descriptions
        bordered
        title="Báo giá chuyển đổi"
        items={items}
        layout="vertical"
        size="small"
        column={2}
      />
    );
  };

  const renderAudioLoading = () => {
    if (audioUrl) return null;
    return (
      <div className="flex min-h-[250px] flex-col items-center justify-center gap-2">
        <Spin />
        <span className="text-center">Đang chờ hệ thống xử lý</span>
      </div>
    );
  };

  const renderAction = () => {
    return (
      <div className="w-full">
        <Button
          loading={loading}
          onClick={() => handleConvertAudio(audioFile)}
          type="primary"
          className="min-h-[40px]"
          block
        >
          Xác nhận sử dụng file này
        </Button>
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------

  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center gap-2">
      {renderAudioPreview()}
      {renderAudioLoading()}
      <Divider dashed className="my-[10px]" />
      {renderAction()}
      <TriggerAudioUrl
        audioFile={audioFile}
        setAudioUrl={setAudioUrl}
        setAudioDuration={setAudioDuration}
      />
    </div>
  );
};
export default PreviewCompleted;
